import ReactDatePicker from "react-datepicker";
import Select from "react-select";
import VesselTableData from "./VesselTableData";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import React, { useRef, useState, useEffect } from "react";
import {
  AreaChart,
  XAxis,
  YAxis,
  CartesianGrid,
  ResponsiveContainer,
  Area,
} from "recharts";
import { Col, Form, Row, Button } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { getPMSanalysisVessel } from "../../../features/THUNK/pmsAnalysisThunk";
import { removeSearchParams } from "../../../helper/Support";
import { constructWaveResponse } from "./Support";
import { ConvertJson } from "../../../helper";
import { toast } from "react-toastify";
import { getAllData } from "../../../features/globalSlice";
import { TYPE_BASED_ON_TYPE } from "../../../constant/CommonApiUrl";

function Charts() {
  const printRef = useRef();
  const dispatch = useDispatch();

  const [year, setYear] = useState(new Date());
  const [vessel, setVessel] = useState([]);
  const [waveData, setWaveData] = useState([]);
  const [pdfenable, setPdfEnable] = useState(false);
  const [activity, setActivity] = useState("");

  const vesselList =
    useSelector((state) => state.root.login.loginDemo?.vesselDetails) || [];
  const vessel_list = vesselList.map((el) =>
    Object.assign({}, { label: el.vessel_name, value: Number(el.id) })
  );
  const { department_wise_data1 } = useSelector((state) => state.root.ANALYSIS);
  const { id: vessel_id, vessel_name } = useSelector(
    (state) => state.root.common.vessel_detailByID
  );
  const activityOption = useSelector((state) =>
    state.root.GLOBAL?.activityOption?.map((el) => (
      <option key={el.id} value={el.typecode}>
        {el.typename}
      </option>
    ))
  );

  const fetchData = (arg) => {
    setVessel(
      vessel_name === "OFFICE"
        ? []
        : vessel_list.filter((el) => el.value === Number(arg.vessel_id))
    );
    dispatch(
      getPMSanalysisVessel(
        removeSearchParams({ year: year.getFullYear(), activity, ...arg })
      )
    )
      .unwrap()
      .then((res) => {
        let d = ConvertJson(res.data.result.data[0].multiple_vessel);
        let a = vessel.map((el) => el.label);
        let b = d.filter((el) => el.vessel_name === a[0])[0];

        d.length === 2
          ? setWaveData(constructWaveResponse(a, b, d))
          : setWaveData(
              d[0]?.vessel_data.map((e) => ({
                ...e,
                month_text: e.job_month_text.substring(0, 3).toUpperCase(),
              }))
            );
      });
  };

  const onSearch = () => {
    if (vessel.length > 0) {
      let vessel_toString = vessel.map((el) => el.value).toString();
      fetchData({ vessel_id: vessel_toString });
    } else {
      toast.error("please select vessel name");
    }
  };

  const handleWave = (selected) => {
    setVessel(selected);
    if (selected.length > 0) {
      let vessel_toString = selected.map((el) => el.value).toString();
      dispatch(
        getPMSanalysisVessel(
          removeSearchParams({
            year: year.getFullYear(),
            activity,
            vessel_id: vessel_toString,
          })
        )
      )
        .unwrap()
        .then((res) => {
          let d = ConvertJson(res.data.result.data[0].multiple_vessel);
          let a = selected.map((el) => el.label);
          let b = d.filter((el) => el.vessel_name === a[0])[0];

          d.length === 2
            ? setWaveData(constructWaveResponse(a, b, d))
            : setWaveData(d[0]?.vessel_data);
        });
    }
  };

  const handleExport = () => setPdfEnable(!pdfenable);

  const exportPdf = () => {
    handleExport();
    handleExportPdf();
  };

  const handleExportPdf = async () => {
    const element = printRef.current;
    const canvas = await html2canvas(element);
    const data = canvas.toDataURL("image/png");
    const pdf = new jsPDF("p", "mm", "a4");
    const imgProperties = pdf.getImageProperties(data);
    const pdfWidth = pdf.internal.pageSize.getWidth();
    const pdfHeight = (imgProperties.height * pdfWidth) / imgProperties.width;
    const pageHeight = 295;
    let heightLeft = pdfHeight;
    let position = 0;
    pdf.addImage(data, "PNG", 0, position, pdfWidth, pdfHeight);
    heightLeft -= pageHeight;
    while (heightLeft >= 0) {
      position += heightLeft - pdfHeight; // top padding for other pages
      pdf.addPage();
      pdf.addImage(data, "PNG", 0, position, pdfWidth, pdfHeight);
      heightLeft -= pageHeight;
    }
    pdf.save("PMS_analysis.pdf");
    handleExport();
  };

  useEffect(() => {
    dispatch(
      getAllData({ activityOption: `${TYPE_BASED_ON_TYPE}PMS_ACTIVITY` })
    );
    fetchData({ vessel_id });
  }, [vessel_id]);

  return (
    <>
      <Row ref={printRef}>
        <Col className={"mb-3 mt-3"} sm={12}>
          <div
            className={
              "d-flex flex-row justify-content-between align-items-center bg-white p-3 col-md-12"
            }
          >
            <span
              style={{ color: "#1A2261", fontWeight: "800" }}
              className={"me-2"}
            >
              PMS Analysis Report
            </span>
            <Row>
              <Col sm={3}>
                <Select
                  isMulti
                  options={vessel_list}
                  value={vessel}
                  className="basic-multi-select"
                  classNamePrefix="select"
                  isDisabled={vessel_name !== "OFFICE"}
                  onChange={(selected) => {
                    selected.length <= 2
                      ? handleWave(selected)
                      : toast.error("You can only select up to two vessels.");
                  }}
                />
              </Col>

              <Col sm={3}>
                <Form.Select
                  aria-label="Default select example"
                  style={{ width: "150px" }}
                  onChange={(e) => setActivity(e.target.value)}
                >
                  <option value={""}>Activity</option>
                  {activityOption}
                </Form.Select>
              </Col>
              <Col sm={3}>
                <ReactDatePicker
                  className="form-control"
                  selected={year}
                  onChange={(date) => {
                    setYear(date);
                  }}
                  showYearPicker
                  dateFormat="yyyy"
                />
              </Col>
              <Col sm={2}>
                <Button onClick={() => onSearch()}>Search</Button>{" "}
              </Col>
            </Row>
            <div>
              <Button
                onClick={() => {
                  exportPdf();
                }}
              >
                Export&nbsp;Chart
              </Button>{" "}
            </div>
          </div>
          <div
            className={"d-flex justify-content-between mb-2"}
            style={{ width: "100%", height: "300px" }}
          >
            <ResponsiveContainer
              width={"100%"}
              height="100%"
              className={"analysisChart"}
            >
              <AreaChart
                data={waveData}
                margin={{ top: 10, right: 30, left: 0, bottom: 0 }}
              >
                <defs>
                  <linearGradient id="colorUv1" x1="0" y1="0" x2="0" y2="1">
                    <stop offset="5%" stopColor="#A6DFF8" stopOpacity={0.8} />
                    <stop offset="95%" stopColor="#B4E6FC" stopOpacity={0} />
                  </linearGradient>
                  <linearGradient id="colorUv2" x1="0" y1="0" x2="0" y2="1">
                    <stop offset="5%" stopColor="#A6DFF8" stopOpacity={0.8} />
                    <stop offset="95%" stopColor="#B4E6FC" stopOpacity={0} />
                  </linearGradient>
                </defs>
                <XAxis dataKey="month_text" />
                <YAxis />
                <CartesianGrid
                  strokeDasharray="3 3"
                  horizontal={false}
                  vertical={false}
                />
                <Area
                  type="monotone"
                  dataKey="completed"
                  stroke="#3AB6E5"
                  strokeWidth={2}
                  fillOpacity={1}
                  fill="url(#colorUv1)"
                  dot={false}
                />
                <Area
                  type="monotone"
                  dataKey="completed1"
                  stroke="#FFC400"
                  strokeWidth={2}
                  fillOpacity={1}
                  fill="url(#colorUv2)"
                  dot={false}
                />
              </AreaChart>
            </ResponsiveContainer>
          </div>
        </Col>
      </Row>
      {department_wise_data1 &&
        department_wise_data1.length > 0 &&
        department_wise_data1.map((el, i) => (
          <VesselTableData
            key={i}
            vesselData={el}
            vesselName={el.vessel_name}
            VesselColor={i === 0 ? "icons sky-blue" : "icons orange"}
          />
        ))}
      <hr className="mb-3" />
    </>
  );
}

export default Charts;
